import { Handle, Position } from '@xyflow/react'
import { variableDefs } from '../../lib/animVariables'

export function GetVariableNode({ data, selected }) {
  const varName = data.variableName ?? ''
const def     = variableDefs.find(d => d.name === varName)
  const color   = def?.type === 'bool' ? '#60d090'
                : def?.type === 'int'  ? '#60b0d0'
                : '#c080e0'

  return (
    <div style={{
      background: selected ? '#1a1225' : '#110d1a',
      border: `2px solid ${selected ? color : '#3a2060'}`,
      borderRadius: 6,
      minWidth: 160,
      fontFamily: 'var(--m-font)',
      fontSize: 12,
    }}>
      <div style={{
        background: '#1e1030',
        padding: '6px 14px',
        borderBottom: '1px solid #2a1848',
        borderRadius: '4px 4px 0 0',
        display: 'flex', alignItems: 'center', gap: 6,
      }}>
        <span style={{ color, fontWeight: 'bold', fontSize: 10, letterSpacing: 0.5 }}>GET VARIABLE</span>
        <Handle
          type="source"
          position={Position.Right}
          id="value"
          style={{ background: color, width: 10, height: 10, borderRadius: '50%' }}
        />
      </div>

      <div style={{ padding: '8px 12px' }}>
        <select
          value={varName}
          onChange={e => data.onChange?.('variableName', e.target.value)}
          onMouseDown={e => e.stopPropagation()}
          style={{
            width: '100%',
            background: '#0d0a14',
            border: '1px solid #2a1848',
            color: varName ? color : '#555',
            padding: '4px 6px',
            borderRadius: 3,
            fontSize: 10,
            fontFamily: 'var(--m-mono)',
            outline: 'none',
            cursor: 'pointer',
          }}
        >
          <option value="">— select —</option>
          {variableDefs.map(d => (
            <option key={d.name} value={d.name}>{d.name} ({d.type})</option>
          ))}
        </select>
        {def && (
          <div style={{ color: '#50385a', fontSize: 9, marginTop: 4, textAlign: 'right' }}>
            default: {String(def.defaultValue)}
          </div>
        )}
      </div>
    </div>
  )
}
